const _duty = {
	title: '<span>Producción</span><span>Audiovisual</span>',
	subtitle: '',
	description:
		'<p class="lead">Somos una productora audiovisual con más de quince años de experiencia desarrollando contenido corporativo y de publicidad, reportajes y cine documental.</p><p class="lead mb-0">En OnFocus Media ponemos al servicio de nuestros clientes los equipos más modernos y versátiles del mercado para ofrecer a nuestros clientes una producción audiovisual completa, desde la ideación y desarrollo del concepto, hasta la entrega final.</p>',
	items: [
		{
			id: 1,
			icon: 'video',
			title: 'Filmación',
			subtitle: '',
			description:
				'El estilo de filmación cinematográfico es nuestra seña de identidad gracias a que contamos con equipos de última generación y a la pasión de un gran equipo de profesionales con años de experiencia en una gran variedad de producciones audiovisuales.'
		},
		{
			id: 2,
			icon: 'film',
			title: 'Edición y postproducción',
			subtitle: '',
			description:
				'Realizamos todo el proceso final de maquetación y postproducción digital de vídeo y audio utilizando el material filmado por nuestro equipo o el proporcionado por el cliente. '
		},
		{
			id: 3,
			icon: 'cube',
			title: 'Animación 2D y 3D',
			subtitle: '',
			description:
				'Te ayudamos a encontrar la mejor solución para tu proyecto utilizando avanzado software de última generación para el desarrollo de proyectos que requieran de animación 2D y 3D.'
		},
		{
			id: 4,
			icon: 'camera',
			title: 'Fotografía',
			subtitle: '',
			description:
				'Nuestro compromiso es crear imágenes diferentes y atractivas ofreciendo un servicio integral de fotografía para cualquier tipo de evento o estilo fotográfico que necesites cubrir: moda, producto, arquitectónica, social, etc…'
		}
	]
}

export default {
	getData(callback) {
		callback(_duty)
	}
}
